import { render } from "./MinorTip.vue?vue&type=template&id=b44ce102&scoped=true"
import script from "./MinorTip.vue?vue&type=script&lang=js"
export * from "./MinorTip.vue?vue&type=script&lang=js"

import "./MinorTip.vue?vue&type=style&index=0&id=b44ce102&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b44ce102"]])

export default __exports__